import { InputMask } from "@react-input/mask";
import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/user";
import Button from "@/atomic/atoms/Button";

export default function RegisterUserView({
  goBack,
  customer,
  onChange,
  goToAddress,
  isDisabled,
}: PropsView) {
  return (
    <div className="h-full">
      <Header title="Dados Pessoais" hasLeftButton goBack={goBack} />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] h-form">
        <article className="h-full flex flex-col justify-between w-[calc(480px)]">
          <div>
            <h2 className="mt-6 text-black text-xl">Dados Pessoais</h2>
            <div className="flex flex-col justify-center items-center">
              <input
                value={customer?.register?.name ?? ""}
                required
                onChange={onChange}
                type="text"
                name="name"
                placeholder="Nome completo"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              <input
                value={customer?.register?.email ?? ""}
                required
                onChange={onChange}
                type="text"
                inputMode="email"
                name="email"
                placeholder="E-mail"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              <InputMask
                value={customer?.register?.birthdate ?? ""}
                name="birthdate"
                required
                onChange={onChange}
                type="text"
                inputMode="numeric"
                mask="__/__/____"
                replacement={{ _: /\d/ }}
                placeholder="Data de nascimento"
                className="mt-5 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
            </div>
          </div>
          <Button
            title="Continuar"
            onClick={goToAddress}
            type="submit"
            isDisabled={isDisabled}
          />
        </article>
      </main>
    </div>
  );
}
